import React from 'react';
import {DeprecatedScrollbar, Scrollbar} from '@forecast-it/design-system';

type NativeScrollProps = {
	nativeMaxHeight?: number;
	isPageScroller?: boolean;
	hasFocusableContent?: boolean;
	onNativeScroll?: React.UIEventHandler<HTMLDivElement>;
};

type DeprecatedScrollProps = {
	[key: string]: unknown;
};

// Converter component for transitioning from DeprecatedScrollbar to Native Scrollbar from DS
interface DeprecatedScrollToNativeScrollProps extends NativeScrollProps, DeprecatedScrollProps {
	forceDeprecatedScroll?: boolean; // For debugging
	children: React.ReactNode;
}
const DeprecatedScrollToNativeScroll = ({
	forceDeprecatedScroll,
	nativeMaxHeight,
	isPageScroller,
	hasFocusableContent,
	onNativeScroll,
	children,
	...props
}: DeprecatedScrollToNativeScrollProps): JSX.Element => {
	if (!forceDeprecatedScroll) {
		return (
			<Scrollbar
				maxHeight={nativeMaxHeight}
				onScroll={onNativeScroll}
				isPageScroller={isPageScroller}
				hasFocusableContent={hasFocusableContent}
			>
				{children}
			</Scrollbar>
		);
	}
	return <DeprecatedScrollbar {...props}>{children}</DeprecatedScrollbar>;
};

export default DeprecatedScrollToNativeScroll;
